// @ts-nocheck
import axios from 'axios'
import $axios, { axoiosInstance } from './axios/index'
import 'url-search-params-polyfill'
export function getApiData(url, param) {
  for (const attr in param) {
    if (param[attr] == null) {
      delete param[attr]
    }
  }
  const params = {
    params: param
  }

  return $axios(url + '?' + new Date().getTime(), 'get', params)
}

export function postApiData(url, param) {
  for (const attr in param) {
    if (param[attr] == null) {
      delete param[attr]
    }
  }
  const data = new URLSearchParams()
  for (const attr in param) {
    data.append(attr, param[attr])
  }
  param = data
  return $axios(url, 'post', param)
}

export function allApi(promiseArray) {
  return new Promise((resolve, reject) => {
    axios
      .all(promiseArray)
      .then(allResponse => {
        resolve(allResponse)
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function uploadFile(method, url, params) {
  const axoiosInstance = axios.create({
    // @ts-ignore
    crossDomain: true,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    withCredentials: true
  })
  return new Promise((resolve, reject) => {
    axoiosInstance[method](url, params || {})
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        }
      })
      .catch(error => {
        reject(error)
      })
  })
}

export function getApiJSON(url, param) {
  return new Promise((resolve, reject) => {
    axoiosInstance({
      url: `${gisserverUrl}` + url + '?' + new Date().getTime(),
      method: 'get',
      data: param,
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        }
      })
      // eslint-disable-next-line handle-callback-err
      .catch(error => {
        //
      })
  })
}

export function postApiJSON(url, params) {
  return new Promise((resolve, reject) => {
    axoiosInstance({
      url: `${gisserverUrl}` + url,
      method: 'post',
      data: JSON.stringify(params),
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
      .then(response => {
        if (response.status === 200) {
          resolve(response.data)
        }
      })
      // eslint-disable-next-line handle-callback-err
      .catch(error => {
        //
      })
  })
}

export function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}
